(function() {
  'use strict';

  window.DASHBOARD_STORAGE_KEY = 'malhardashboard';

  /**
   * DashboardController declaration
   */
  angular
    .module('webAgro1App')
    .controller('DashboardCtrl', DashboardController);

  /**
   * DashboardController dependencies
   * @type {Array}
   */
  DashboardController.$inject = [
    '$scope',
    '$rootScope',
    '$location',
    'StorageService',
    'Flash',
    'dashboardRegisteredWidgets',
    'LoadingService',
    '$timeout'
  ];

  /**
   * DashboardController function
   */
  // eslint-disable-next-line max-lines-per-function, max-params
  function DashboardController($scope, $rootScope, $location, StorageService,
    Flash, dashboardRegisteredWidgets, LoadingService, $timeout) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.options = {
      widgetDefinitions: dashboardRegisteredWidgets,
      defaultWidgets: [
        { name: 'widgetPragasvsAplicacoes' },
        { name: 'widgetTalhoesDiasSemVisita' },
        { name: 'widgetCronograma' }
      ],

      storage: {
        getItem: StorageService.get,
        setItem: StorageService.set,
        removeItem: StorageService.remove
      },
      storageId: DASHBOARD_STORAGE_KEY,
      stringifyStorage: false,
      explicitSave: true
    };
    vm.loadedMapsApi = false;
    vm.glebas = [];

    //////////////////////////////////////////
    // Bindable methods
    vm.saveEnabled = saveEnabled;
    vm.manageWidgetWidthOnPrint = manageWidgetWidthOnPrint;

    //////////////////////////////////////////
    // Function declarations

    /**
     * Show or hide save button for dashboard changes
     * @param {Number} unsavedChanges amount of dashboard changes to persist
     * @return {Boolean}
     */
    function saveEnabled(unsavedChanges) {
      return !!unsavedChanges && unsavedChanges > 0;
    }

    function manageWidgetWidthOnPrint(widget, event) {
      event.stopPropagation();
      const originalWidth = widget.containerStyle.width;
      widget.setWidth('1100px');
      $timeout(() => {
        angular.element(event.target.parentElement).click();
      }, 500);
      $timeout(() => {
        widget.setWidth(originalWidth);
      }, 600);
    }

    //////////////////////////////////////////
    // Controller logic
    $rootScope.bodyClass = 'agro-dashboard';

    LoadingService.showLoading();

    $rootScope.initialize.then(function() {
      if (!$rootScope.permissions.dashboard.canRead) {
        $location.path('/');
        Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
      } else {
        vm.loadedMapsApi = true;

        vm.glebas = $rootScope.currentPropriedade.glebas.map(function(gleba) {
          return {
            id: gleba.id,
            descricao: gleba.descricao,
            global: true
          };
        });

        if (!$rootScope.globalSafra) {
          $rootScope.globalSafra = $rootScope.safras.find(function(safra) {
            return safra.current;
          });
        }
      }
    }, $rootScope.errorRootInitialize).finally(LoadingService.hideLoading);
  }
}());
